import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const KetilImage = (props) => {
  const data = useStaticQuery(graphql`
    query {
      ketilImage: file(
        relativePath: {
          eq: "components/pages/WealthPage/Sections/TeamSection/images/board-image.jpg"
        }
      ) {
        childImageSharp {
          fluid(
            quality: 100
            maxWidth: 1350
            maxHeight: 3100
            cropFocus: EAST
          ) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.ketilImage.childImageSharp.fluid} {...props} />
}

export default KetilImage
